import {useMemo} from "react";
import style from "./Cargo.module.css";

type IconProps = {
    value: boolean
}
type BarProps = {
    label: string,
    value: number,
    max: number,
}

export const HangarBayIcon = ({value}: IconProps) => {
    return (value ? (
        <img className={style.featureIcon} src="https://img.swcombine.com//client/icons/hangarBay1.gif" alt="Hangar Bay" title="Hangar Bay" />
    ) : (
        <div className={style.featureIcon} />
    ))
}

export const DockingBayIcon = ({value}: IconProps) => {
    return (value ? (
        <img className={style.featureIcon} src="https://img.swcombine.com//client/icons/dockingBay1.gif" alt="Docking Bay" title="Docking Bay" />
    ) : (
        <div className={style.featureIcon} />
    ))
}

export const LandingIcon = ({value}: IconProps) => {
    return (value ? (
        <img className={style.featureIcon} src="https://images.swcombine.com//client/icons/landing1.gif" alt="Landing" title="Landing Capacity"/>
    ) : (
        <div className={style.featureIcon}/>
    ));
}


export const CargoBar = ({label, value, max}: BarProps) => {
    if (value > max) {
        return (
            <div className={style.healthContainer}>
                <div className={style.healthBar} style={{backgroundColor: 'darkred', width: "100%"}} />
                <div className={style.healthLabel}>{label}: OVER LIMIT</div>
            </div>
        )
    }

    const color = useMemo(() => getColor(value, max), [value, max]);

    return (
        <div className={style.healthContainer}>
            <div className={style.healthBar} style={{backgroundColor: color, width: (100*value/max)+"%"}} />
            <div className={style.healthLabel}>{label}: {value.toLocaleString()}/{max.toLocaleString()}</div>
        </div>
    )
}
const getColor = (value: number, max: number) => {
    if(value===max) {
        return '#ff0000';

    }
    let ratio = value/max;
    if(ratio>0.75) {
        return '#ff9900';
    }
    if(ratio>0.50) {
        return '#cccc00';
    }
    if(ratio>0.25) {
        return '#3aa13a';
    }
    return '#008000'

}
